/**
 * The demo dataset and the Step 1 panel's promised downloads
 * (DESIGN_RECORD item 5), embedded as the single source of truth.
 *
 * MAINE_COUNTY_POVERTY_SAMPLE_CSV is the mockup's sample file: Maine's
 * sixteen counties, percent-scale direct estimates with percent-
 * squared sampling variances (30.25 is 5.5 squared), respondent
 * counts, and three covariates. The identical bytes are served as
 * packages/io/assets/maine_county_poverty_sample.csv — a test asserts
 * the asset file and this constant never drift apart. (The mockup
 * preview renders incomes with thousands separators for display; the
 * file itself stores plain numbers, 41200, so the CSV parses.)
 *
 * The population column was added for re-review RB-4 (fix 4): the
 * demo previously carried no population counts, so every default
 * demo run skipped benchmarking and sat outside the validated
 * configuration. The figures are the counties' total populations
 * from the U.S. Census Bureau, 2020 Census Redistricting Data
 * (Public Law 94-171) Summary File, Maine, Table P1, retrieved
 * 2026-10-18 from the Bureau's published state file
 * (me2020.pl.zip). They are exact counts, not estimates or rounded
 * values: the sixteen county figures sum to the file's published
 * state total of 1,362,359.
 *
 * The demo indicator is the all-persons county poverty rate, so
 * these total-population counts are the matching benchmark
 * weights for it: the benchmark target for a total-population
 * rate is the total-population-weighted direct estimate. (An
 * adult-only indicator would require 18-and-over counts as its
 * weights instead; that case does not arise here.)
 *
 * AREA_LEVEL_TEMPLATE_CSV is the panel's blank template download,
 * byte-identical to the mockup's template generator.
 */
export const MAINE_COUNTY_POVERTY_SAMPLE_CSV = `county,direct_pct,sampling_variance,n,snap_rate,unemployment_rate,median_household_income,population
Piscataquis,19.6,30.25,42,21.4,6.8,41200,16800
Washington,18.9,17.64,88,20.1,7.4,43800,31095
Somerset,17.8,12.96,112,19.6,6.9,46100,50477
Aroostook,16.4,9.00,164,18.2,6.1,47500,67105
Androscoggin,15.2,4.84,268,16.8,5.2,54200,111139
Penobscot,15.0,4.00,342,16.1,5.4,51800,152199
Oxford,14.7,9.61,128,15.9,5.8,50600,57777
Franklin,13.9,19.36,64,15.2,5.6,48900,29456
Waldo,13.6,11.56,96,14.8,5.1,53400,39607
Kennebec,12.8,4.00,288,14.1,4.9,56700,123642
Hancock,12.1,8.41,118,13.4,4.7,58900,55478
Knox,11.4,10.24,84,12.6,4.5,61200,40607
Lincoln,10.8,10.89,78,11.9,4.3,63400,35237
Sagadahoc,9.2,14.44,58,10.8,3.9,69800,36699
York,9.4,2.25,412,10.5,3.8,72600,211972
Cumberland,7.8,1.44,524,8.9,3.4,82400,303069
`;
export const AREA_LEVEL_TEMPLATE_CSV = 'area,direct_estimate,sampling_variance,n,covariate_1,covariate_2\n';
//# sourceMappingURL=demo-data.js.map